/* global COUNTRY_CODE */
/* global TruTranslations */
/* global return_link */

const PROVINCES = ['ON', 'AB', 'BC', 'QC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'PE', 'SK', 'YT'];
let postal_to_provinces = {
    'A': ['NL'],
    'B': ['NS'],
    'C': ['PE'],
    'E': ['NB'],
    'G': ['QC'],
    'H': ['QC'],
    'J': ['QC'],
    'K': ['ON'],
    'L': ['ON'],
    'M': ['ON'],
    'N': ['ON'],
    'P': ['ON'],
    'R': ['MB'],
    'S': ['SK'],
    'T': ['AB'],
    'V': ['BC'],
    'X': ['NT', 'NU'],
    'Y': ['YT'],
}

let zone_to_provinces = {
    'ON': ['ON'],
    'AB': ['AB'],
    'BC': ['BC'],
    'QC': ['QC'],
    'NATION': ['MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'PE', 'QC', 'SK', 'YT'],
}

const CheckoutValidation = {
    checkWelcomePostal(){
        let postal_field = this.getPostalField();
        let search_field = $( "input[name='search']" );

        if (this.isValidPostalCode(postal_field.val())) {
            $(".welcome-content__form-error").hide();
            postal_field.removeClass("input-error");
            search_field.removeClass("input-error");
            return true;
        } else {
            $(".welcome-content__form-error").show();
            postal_field.addClass("input-error");
            search_field.addClass("input-error");
            $( "#form__submit" ).removeClass('loading').attr('disabled', false);
            return false;
        }
    },

    getPostalField() {
        let postal_field = $("input[name='postal_code']");
        if (!postal_field.length) {
            // Use the non-autocomplete field
            postal_field = $("input[name='postal_code--no-auto']");
        }
        return postal_field;
    },

    getPostalProvinceError(postalCode, prov, zones) {
      // postal code is not in user's provided province
      if (!postal_to_provinces[postalCode[0].toUpperCase()].includes(prov))
        return TruTranslations['postal_code_province_mismatch'];

      // see if product's zones service the province
      for (let z of zones)
        if (zone_to_provinces[z].includes(prov))
          return '';  // success, no error message

      // postal code is not in the product's zone
      if (typeof return_link !== 'string')
        return TruTranslations['checkout_product_not_in_area'];

      // provide user with a link for their region
      let urlString = return_link + "?region="
      if (!['AB', 'BC', 'ON'].includes(prov)) prov = 'NATION';
      urlString += prov;
      return TruTranslations['curated_box_not_available_in_your_region'].replace('<url>', urlString);
    },

    validatePostalCodeAndProvince(zones, valid, focus_on, billing=false) {
        let postal_field = this.getPostalField();
        let province_field = $("#province");
        if (billing) {
          postal_field = $("input[name='billing-postal_code']");
          province_field = $("#billing-province");
        }

        // if both fields don't exist, likely a gift card, return valid
        if (postal_field.length === 0 && province_field.length === 0) return valid;

        // validate postal code field
        let postalCode = "";
        let postalValid = false;
        if (postal_field.length) {
          postalCode = postal_field.val().trim().toUpperCase();
          postalValid = this.isValidPostalCode(postalCode);
          valid = this.validateField(postal_field, valid, focus_on, postalValid, TruTranslations['checkout_postal_required']);
        }

        // validate province field
        if (province_field.length === 0) return valid;  // don't need to check province or postal/province mismatch
        const prov = province_field.val();
        const provValid = COUNTRY_CODE === 'US' ? !!prov : PROVINCES.includes(prov);
        valid = this.validateField(province_field, valid, focus_on, provValid, TruTranslations['checkout_province_required']);

        // if either US or postal/province are invalid -> don't compare them
        if (COUNTRY_CODE === 'US' || !postalValid || !provValid) return valid;

        // determine if province and postal code match
        const errMsg = zones && postalValid && provValid ? this.getPostalProvinceError(postalCode, prov, zones) : "";
        if (!errMsg) return valid;  // no postal/province mismatch, success return here

        // mark postal code and province fields as having an error
        postal_field.addClass('error');
        province_field.addClass('error');

        this.showErrors(errMsg);
        if (valid) this.fieldFocus(this.errorField);

        return false;
    },

    fieldFocus(fieldToFocus) {
        try {
            $('html, body').animate({
                scrollTop: fieldToFocus.offset().top
            }, 750);
        } catch (e) { /* do nothing */ }
    },

    isValidPostalCode(postalCode) {
      if (COUNTRY_CODE === 'US')
        return /^\d{5}(-\d{4})?$/.test(postalCode);
      else
        return /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ][ ]?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/
            .test(postalCode.replace(" ", "").toUpperCase());
    },

    isValidEmail(email) {
        // email address can be stored in our DB
        if (email.length > 255) return false;

        // username exists
        let posAt = email.indexOf('@');
        if (posAt <= 0) return false;

        // domain length
        let domain = email.substring(posAt + 1);
        if (domain.length > 67) return false;

        // domain regex format
        return domain.match(/^([a-z0-9][a-z0-9-]{0,63}\.){1,6}[a-z]{2,64}$/gi) !== null;
    },

    toggleFields() {
        let building_type_field = $("#building_type");
        let apartment_disclaimer = $('#apartmentDisclaimer');
        let confirm_container = $('#building_type_confirm_container');
        let disclaimer_checkbox = $('#disclaimer-checkbox');

        // Validate Building Type
        apartment_disclaimer.hide();
        confirm_container.hide();

        // if there's no building_type selected (or existing) then no disclaimer checkbox needed
        if (!building_type_field.val()) return;

        // confirmation of disclaimer needed
        confirm_container.show();
        disclaimer_checkbox.prop("checked", false);
        if (building_type_field.val() === 'Apartment') {
            // apartments get an extra disclaimer
            apartment_disclaimer.show();
        }
    },

    validateStep1() {
      this.clearErrors();

      let valid = this.validateEmailField($('#email'), true);
      valid = this.validatePasswordField($('#password'), valid);

      return valid;
    },

    validateCCDonateStep2() {
      this.clearErrors();

      let valid = this.validateField($('#employee_code'), true, null, null, TruTranslations['redemption_code_required']);
      valid = this.validateAddressFields(null, valid);

      return valid;
    },

    validateStep2(zones, checkTermsCheckbox=false) {
      this.clearErrors();

      let valid = this.validateField($('#employee_code'), true, null, null, TruTranslations['redemption_code_required']);
      valid = this.validateShippingDate($('#giftShippingDate'), valid);
      valid = this.validateField($('#purchaserFirstName'), valid, null, null, TruTranslations['purchaser_first_name_required']);
      valid = this.validateField($('#purchaserLastName'), valid, null, null, TruTranslations['purchaser_last_name_required']);
      valid = this.validateEmailField($('#recipientEmail'), valid);
      valid = this.validateAddressFields(zones, valid);
      valid = this.validateGiftCardAmount($('#giftCardAmount'), valid);
      valid = this.validateCheckbox($('#disclaimer-checkbox'), valid, $('#disclaimerSection'));
      if (checkTermsCheckbox) valid = this.validateCheckbox($('#terms-checkbox'), valid);

      return valid;
    },

    validateBilling(zones) {
      this.clearErrors();
      let valid = true;

      valid = this.validateField($('#cardholder_name'), valid, null, null, TruTranslations['cardholder_name_is_required']);
      let acf = $('#billing-autocompleteFields').is(':visible') ? $('#billing-autocompleteFields') : $('#billing-manualEntryFields');
      valid = this.validateStreetAddress($('#billing-street-address'), valid, acf);
      valid = this.validateCity($('#billing-city'), valid, acf);
      valid = this.validatePostalCodeAndProvince(null, valid, acf, true);
      valid = this.validateCheckbox($('#terms-checkbox'), valid)

      return valid;
    },

    validateField(field, valid, focus_on=null, isValid=null, errMsg=null) {
      if (field.length === 0) return valid;

      if (isValid || (isValid === null && field.val() !== "")) {
        field.removeClass('error');
        return valid
      }

      if (errMsg) this.showErrors(errMsg);
      field.addClass('error');
      if (valid) this.fieldFocus(focus_on ? focus_on : field.parent());
      return false
    },

    validateEmailField(field, valid, focus_on=null) {
      if (field.length === 0) return valid;
      const isValid = this.isValidEmail(field.val());
      return this.validateField(field, valid, focus_on, isValid, TruTranslations['checkout_invalid_email']);
    },

    validatePasswordField(field, valid, focus_on=null) {
      if (field.length === 0) return valid;
      const passwordLength = field.val().length;
      const isValid = passwordLength >= 6 && passwordLength <= 72;
      return this.validateField(field, valid, focus_on, isValid, TruTranslations['password_is_required']);
    },

    validateShippingDate(field, valid, focus_on=null) {
      if (field.length === 0) return valid;
      const isValid = field[0].selectedIndex !== 0;
      return this.validateField(field, valid, focus_on, isValid, TruTranslations['select_shipping_date']);
    },

    validatePhone(field, valid, focus_on=null) {
      // Ensure the phone number is exactly 10 digits excluding special characters added by the mask.
      if (field.length === 0) return valid;
      let n = field.val().replace(/[()\- ]/g, '');
      let isValid = n.match(/[0-9]{10}/g) !== null;
      return this.validateField(field, valid, focus_on, isValid, TruTranslations['phone_is_required'])
    },

    validateAddressFields(zones, valid) {
      // all address field errors should focus on the top of autocompleteFields;
      // however, if in manual mode, focus on the top of the manualEntryFields
      let acf = $('#autocompleteFields').is(':visible') ? $('#autocompleteFields') : $('#manualEntryFields');
      valid = this.validateFirstName($('#first_name'), valid);
      valid = this.validateLastName($('#last_name'), valid);
      valid = this.validatePhone($('#phone'), valid);
      valid = this.validateStreetAddress($('#street-address'), valid, acf);
      valid = this.validateCity($('#city'), valid, acf);
      valid = this.validatePostalCodeAndProvince(zones, valid, acf);
      valid = this.validateField($("#building_type"), valid, acf, null, TruTranslations['checkout_building_required']);
      return valid;
    },

    validateFirstName(field, valid) {
      return this.validateField(field, valid, null, null, TruTranslations['first_name_is_required']);
    },

    validateLastName(field, valid) {
      return this.validateField(field, valid, null, null, TruTranslations['last_name_is_required']);
    },

    validateStreetAddress(field, valid, focus_on=null) {
      return this.validateField(field, valid, focus_on, null, TruTranslations['checkout_address_required']);
    },

    validateCity(field, valid, focus_on) {
      return this.validateField(field, valid, focus_on, null, TruTranslations['checkout_city_required']);
    },

    validateCheckbox(field, valid, focus_on=null) {
      if (field.length === 0) return valid;
      return this.validateField(field, valid, focus_on, field[0].checked, TruTranslations['please_check_box_to_agree']);
    },

    validateGiftCardAmount(field, valid) {
      // get the gift card amount
      let gc_amount = $('#giftCardAmount').val()

      // skip validation if there is no gift card amount (i.e. not a gift card purchase)
      if (!(gc_amount)) return valid;
      if (gc_amount == 'custom') gc_amount = $('#customGiftCardAmount').val();

      // validate amount
      let isValid = /^\d{2,5}(.\d{1,2})?$/.test(gc_amount) && gc_amount >= 25;
      return this.validateField(field, valid, $('#checkout-errors'), isValid, TruTranslations['gift_card_amount_invalid'])
    },

    showErrors(errMsg=null) {
      if (this.errors === undefined) this.errors = [];
      if (errMsg) this.errors.push(errMsg);
      let errorField = $('#checkout-errors');
      errorField.html(`<span class="messages">${this.errors.join('<br>')}</span>`);
      errorField.show();
    },

    clearErrors() {
      this.errors = [];
      $('#checkout-errors').hide();
    },

    postalZone(postal){
      if (postal.match(/^\d/)) return 'IL';
      switch (postal.substring(0,1).toLowerCase()) {
      case 'a':
      case 'b':
      case 'c':
      case 'e':
      case 'g':
      case 'h':
      case 'j':
        return 'NATION';
      case 'k':
      case 'l':
      case 'm':
      case 'n':
      case 'p':
        return 'ON';
      case 't':
        return 'AB';
      case 'v':
        return 'BC';
      }
      return '';
    },
};

export default CheckoutValidation;
